import constants from "src/constants";
import translate from "src/functions/translate";

function countryNameText(
  locale: string,
  lang: string,
  country: string,
  city: string
) {
  const code = country || locale || constants.Locales._default.lang;
  return city
    ? city
    : code &&
        translate(constants.Locales[String(code).toLowerCase()]?.country, lang);
}

export default countryNameText;
